import React from 'react';
import ReportingBookingPage from '../components/ReportingBookingPage';

const axios = require('axios').default;

const ReportingBookingApp = (props) => {
  if (props.csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  return <ReportingBookingPage {...props} />;
};

export default ReportingBookingApp;
